import { Button } from "@/modules/shadcn/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/modules/shadcn/ui/dialog";
import { useGetProjectLabelsQuery } from "@/modules/project/services/projectApi";
import { useTranslation } from "react-i18next";
import { EvalActionsSection } from "../EvalActions";
import { GeneralSection } from "./GeneralSection";
import { LimitsSection } from "./LimitsSection";
import { SetupSection } from "./SetupSection";
import { useLimitForm } from "./useLimitForm.hook";

export type CreateLimitModalProps = {
  projectId: number;
  configId: number;
  testCaseId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const CreateLimitModal = ({
  projectId,
  configId,
  testCaseId,
  open,
  onOpenChange,
}: CreateLimitModalProps) => {
  const { t } = useTranslation(["evaluation", "common"]);
  const { form, isSubmitting } = useLimitForm({
    projectId,
    configId,
    testCaseId,
    onSuccess: () => onOpenChange(false),
  });

  const { data: labels = [] } = useGetProjectLabelsQuery({ projectId });
  const labelOptions = labels.map((l) => ({ label: l.name, value: String(l.id) }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[calc(100vh-4rem)] overflow-y-auto sm:max-w-6xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">
            {t("limitForm.addTitle")}
          </DialogTitle>
        </DialogHeader>

        <form.AppForm>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              form.handleSubmit();
            }}
            className="flex flex-col gap-8"
          >
            <GeneralSection />
            <SetupSection labelOptions={[...labelOptions]} />
            <LimitsSection labelOptions={labelOptions} />
            <EvalActionsSection />

            <DialogFooter>
              <DialogClose render={<Button type="button" variant="outline" />}>
                {t("common:actions.cancel")}
              </DialogClose>
              <Button type="submit" disabled={isSubmitting}>
                {t("common:actions.save")}
              </Button>
            </DialogFooter>
          </form>
        </form.AppForm>
      </DialogContent>
    </Dialog>
  );
};
